{
  "endTime": "종료 시간",
  "startTime": "시작 시간",
  "time": "시간"
}
